const class2type = {};
const toString = class2type.toString;
const  getProto = Object.getPrototypeOf;
const hasOwn = class2type.hasOwnProperty;
const ObjectFunctionString = toString.call( Object );
/**
 * æ¯å¦ä¸ºå½æ°
 * @param obj
 */
export const isFunction = (obj: any) => {
    return typeof obj === 'function' && typeof obj.nodeType !== 'number';
};

/**
 * æ¯å¦ä¸ºå¨å±å¯¹è±¡
 * @param obj
 */
export const isWindow = (obj: any) => {
    return obj != null && obj === obj.window;
};
/**
 * æ¯å¦ä¸ºå¯¹è±¡
 * @param obj
 */
export const isPlainObject = (obj: any) => {
    let proto, Ctor;

    // Detect obvious negatives
    // Use toString instead of jQuery.type to catch host objects
    if ( !obj || toString.call( obj ) !== '[object Object]' ) {
        return false;
    }

    proto = getProto( obj );

    // Objects with no prototype (e.g., `Object.create( null )`) are plain
    if ( !proto ) {
        return true;
    }

    // Objects with prototype are plain iff they were constructed by a global Object function
    Ctor = hasOwn.call( proto, 'constructor' ) && proto.constructor;
    return typeof Ctor === 'function' && toString.call( Ctor ) === ObjectFunctionString;
};

export const extend = (...args: any[]) => {

    let src, copyIsArray, copy, name, options, clone,
    target = args[0] || {},
    i = 1,
    deep = false;
        const  length = args.length;
        // Handle a deep copy situation
        if ( typeof target === 'boolean' ) {
            deep = target;

            // skip the boolean and the target
            target = args[ i ] || {};
            i++;
        }

        // Handle case when target is a string or something (possible in deep copy)
        if ( typeof target !== 'object' && !isFunction(target) ) {
            target = {};
        }

        // extend jQuery itself if only one argument is passed
        // if ( i === length ) {
        //     target = this;
        //     i--;
        // }

        for ( ; i < length; i++ ) {
            // Only deal with non-null/undefined values
            if ( (options = args[ i ]) != null ) {

                // Extend the base object
                // tslint:disable-next-line:forin
                for ( name in options ) {
                    src = target[ name ];
                    copy = options[ name ];

                    // Prevent never-ending loop
                    if ( target === copy ) {
                        continue;
                    }

                    // Recurse if we're merging plain objects or arrays
                    if ( deep && copy && ( isPlainObject( copy ) || ( copyIsArray = Array.isArray( copy ) ) ) ) {

                        if ( copyIsArray ) {
                            copyIsArray = false;
                            clone = src && Array.isArray( src ) ? src : [];

                        } else {
                            clone = src && isPlainObject( src ) ? src : {};
                        }

                        // Never move original objects, clone them
                        target[ name ] = extend( deep, clone, copy );

                    // Don't bring in undefined values
                    } else if ( copy !== undefined ) {
                        target[ name ] = copy;
                    }
                }
            }
        }

        // Return the modified object
        return target;
};
